// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  PREQUAL_REQUEST,
  PREQUAL_REQUEST_SUCCESS,
  PREQUAL_REQUEST_ERROR,
} from "../constants";
import axios from "../../../services/api";

function* prequalRequest() {
  try {
    const response = yield call(axios.get, "/prequal/");

    if (response.data.error) {
      yield put({
        type: PREQUAL_REQUEST_ERROR,
        data: response.data.error,
      });
    } else {
      yield put({
        type: PREQUAL_REQUEST_SUCCESS,
        data: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: PREQUAL_REQUEST_ERROR,
      data: error,
    });
  }
}

export default function*  prequalRequestSaga() {
  yield takeLatest(PREQUAL_REQUEST, prequalRequest);
}
